import { ContactsState } from './types';

export const findPersonById = (state: ContactsState, id: string | null) =>
  state.people.find((person) => person.id === id) ??
  state.searchResults?.find((person) => person.id === id) ??
  (state.deepLinkPerson?.id === id ? state.deepLinkPerson : null);

export const selectSelectedPerson = (state: ContactsState) =>
  findPersonById(state, state.selectedPersonId);

export const selectEditPerson = (state: ContactsState) =>
  findPersonById(state, state.editPersonId);

export const selectDeleteTargetPerson = (state: ContactsState) =>
  findPersonById(state, state.deleteTargetId);
